module.exports = __webpack_public_path__ + "static/media/brand.inverse.a967c7b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand.inverse.png
// module id = 107
// module chunks = 0